module.exports = "/365FarmNet/dist/stockyardCore.9d372fe3bbfb097cd070224885621138.html";